import { aurora as viemAurora } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const aurora = {
  displayName: 'Aurora',
  runtime: 'evm',
  viemChain: viemAurora,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'aurora' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
